// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noScroll {
  overflow: hidden;
}

html {
  background: #f8f8f8;
}

@media (max-width: 1023px) {
  html {
    background: white;
  }
}

/** Hide the show/hide password button in IE */
input::-ms-clear, input::-ms-reveal {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/custom.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf","sourcesContent":[".noScroll {\n  overflow: hidden;\n}\n\nhtml {\n  background: #f8f8f8;\n}\n\n@media (max-width: 1023px) {\n  html {\n    background: white;\n  }\n}\n\n/** Hide the show/hide password button in IE */\ninput::-ms-clear, input::-ms-reveal {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
